import React from "react";
import { Globe } from "lucide-react";
import { useI18n } from "../lib/i18n";

export const LanguagePicker = () => {
    const { lang, setLang, languages, t } = useI18n();
    return (
        <div
            data-testid="language-picker"
            className="flex items-center justify-end gap-2"
        >
            <label
                htmlFor="lang-select"
                className="inline-flex items-center gap-1.5 text-xs font-display font-bold uppercase tracking-[0.18em] text-zinc-500"
            >
                <Globe className="w-3.5 h-3.5" />
                {t("language_label")}
            </label>
            <select
                id="lang-select"
                data-testid="language-select"
                value={lang}
                onChange={(e) => setLang(e.target.value)}
                className="h-9 pl-3 pr-8 rounded-full bg-white border-2 border-zinc-200 hover:border-zinc-400 font-display font-bold text-sm text-zinc-900 tracking-tight focus-visible:ring-2 focus-visible:ring-[#245288]/30 focus-visible:outline-none cursor-pointer transition"
            >
                {languages.map((l) => (
                    <option key={l.code} value={l.code}>
                        {l.label}
                    </option>
                ))}
            </select>
        </div>
    );
};
